const ServerIcon = ({ title = '', ...props }) => (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
    {...props}
  >
    {title && <title>{title}</title>}
    <path d="M24 9.429H3V4h21v5.429Zm-3.281-3.733c-.544 0-.985.456-.985 1.018s.441 1.018.985 1.018c.543 0 .984-.456.984-1.018s-.441-1.018-.984-1.018Zm-2.625 0c-.544 0-.985.456-.985 1.018s.441 1.018.985 1.018c.543 0 .984-.456.984-1.018s-.441-1.018-.984-1.018ZM24 16.214H3v-5.428h21v5.428Zm-3.281-3.732c-.544 0-.985.456-.985 1.018s.441 1.018.985 1.018c.543 0 .984-.456.984-1.018s-.441-1.018-.984-1.018Zm-2.625 0c-.544 0-.985.456-.985 1.018s.441 1.018.985 1.018c.543 0 .984-.456.984-1.018s-.441-1.018-.984-1.018ZM24 23H3v-5.429h21V23Zm-3.281-3.732c-.544 0-.985.456-.985 1.018s.441 1.018.985 1.018c.543 0 .984-.456.984-1.018s-.441-1.018-.984-1.018Zm-2.625 0c-.544 0-.985.456-.985 1.018s.441 1.018.985 1.018c.543 0 .984-.456.984-1.018s-.441-1.018-.984-1.018Z" />
  </svg>
);

export default ServerIcon;
